module.exports = __webpack_public_path__ + "static/media/social-youtube.0a79f899.svg";